module.exports = __webpack_public_path__ + "img/00002.3cd7460e.webp";